import React, { useState, useEffect } from 'react';


export const ProductVideoComponent = ({videoLink, title}) => {
    return <div style={{ display: 'flex', width: '100%', height: '100%' }}>
    <iframe style={{ width: '100%', height: '100%', border: 0 }} src={videoLink} title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" >
    </iframe>
</div>
}